/* Baci — banaku i dyqanit brenda faqes.
   Rregullat qe mban: nuk thote "po pershtatet" pa e ditur gjeneraten dhe vitin; te gjeneratat
   me facelift e pyet vete klientin cilin version e ka; nuk perzien versionet; nuk shpik cmim,
   afat, garancion as montim.

   Mesimet e 2 shtatorit, te ngulitura ketu:
   1) Kerkimi behet me kodin BAZE (F20), jo me "F20 Facelift" — katalogu i shkruan titujt me "LCI".
   2) Burimi eshte /search?view=baci (motori i vertete i kerkimit, i paginuar me 50), jo suggest.json.
   3) Produktet pa stok nuk fshihen: kur pjesa ekziston po s'eshte ne stok, Baci e thote ashtu.
   4) BISEDA NUK MBARON KURRE PA NJE VEND KU KLIENTI LE TE DHENAT: edhe kur pjesa s'eshte ne stok,
      edhe kur s'eshte fare ne katalog, Baci hap nje forme te vogel (emri, telefoni, emaili) qe
      krijon nje Customer ne Shopify me taga — restock:<handle> kur pjesa ekziston, kerkese:<slug>
      kur nuk ekziston — dhe detyra e mengjesit i lexon ato.

   Te dhenat: window.BAJRAMI_FIT (fitment.js) · emri: BaciLabel · filtri: BaciFilter.
   theme.js ka nje handler te vjeter per .baci__form — prandaj degjojme ne fazen e kapjes. */
(function () {
  var root = document.querySelector('[data-baci]');
  if (!root) return;
  var FIT = window.BAJRAMI_FIT || {};
  var thread = root.querySelector('[data-baci-thread]');
  var form = root.querySelector('[data-baci-form]');
  var input = root.querySelector('[data-baci-input]');
  var wa = root.getAttribute('data-wa') || '';
  var L = window.BaciLabel || function (m, l) { return m + ' ' + l; };
  var state = { brand: '', model: '', gen: '', year: 0, part: null };

  var PARTS = [
    { k: 'parakolp', q: 'bumper', paint: 'P1', w: ['bumper'], a: ['parakolp', 'branik', 'bumper'] },
    { k: 'body kit', q: 'body kit', paint: 'P2', w: ['body kit'], a: ['body kit', 'bodykit', 'paket'] },
    { k: 'conversion set', q: 'conversion', paint: 'P2', w: ['conversion'], a: ['conversion', 'konversion'] },
    { k: 'kapak motori', q: 'hood', paint: 'P1', w: ['hood', 'bonnet'], a: ['kapak', 'hauba', 'hood'] },
    { k: 'blatnik', q: 'fender', paint: 'P1', w: ['fender'], a: ['blatnik', 'fender'] },
    { k: 'difuzor', q: 'diffuser', paint: 'GB', w: ['diffuser'], a: ['difuzor', 'diffuser'] },
    { k: 'spoiler', q: 'spoiler', paint: 'GB', w: ['spoiler'], a: ['spoiler'] },
    { k: 'front lip', q: 'front lip', paint: 'GB', w: ['lip', 'splitter'], a: ['lip', 'splitter'] },
    { k: 'grill', q: 'grill', paint: 'GB', w: ['grill'], a: ['grill', 'grila', 'maska'] },
    { k: 'pragje', q: 'side skirts', paint: 'GB', w: ['skirt', 'side step'], a: ['pragje', 'skirt', 'side steps'] },
    { k: 'fener', q: 'headlight', paint: 'NO', w: ['headlight'], a: ['fener', 'headlight', 'drita para'] },
    { k: 'stop', q: 'taillight', paint: 'NO', w: ['taillight', 'tail light'], a: ['stop', 'stopa', 'taillight', 'drita mbrapa'] },
    { k: 'auspuh', q: 'exhaust', paint: 'NO', w: ['exhaust', 'tip'], a: ['auspuh', 'exhaust', 'marmit'] }
  ];

  function norm(s) {
    return (s || '').toLowerCase().replace(/ë/g, 'e').replace(/ç/g, 'c')
      .replace(/[^a-z0-9\s\.\-]/g, ' ').replace(/\s+/g, ' ').trim();
  }
  function slug(s) { return norm(s).replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').slice(0, 60); }
  function esc(s) {
    return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }
  function say(html, who) {
    var d = document.createElement('div');
    d.className = 'bacimsg bacimsg--' + (who || 'baci');
    d.innerHTML = html;
    thread.appendChild(d);
    thread.scrollTop = thread.scrollHeight;
    return d;
  }
  function typing() { return say('<span class="bacidots"><i></i><i></i><i></i></span>', 'baci'); }
  function chips(list) {
    var h = '<div class="bacichips">';
    for (var i = 0; i < list.length; i++) h += '<button type="button" class="chip bacichip" data-baci-send="' + esc(list[i].send) + '">' + esc(list[i].label) + '</button>';
    return h + '</div>';
  }
  function waLink(text) {
    if (!wa) return '';
    return '<a class="bacilink" target="_blank" rel="noopener" href="https://wa.me/' + wa + '?text=' + encodeURIComponent(text) + '">Vazhdo në WhatsApp</a>';
  }
  /* forma e vogel brenda bisedes: krijon Customer ne Shopify me tagat e dhena */
  function leadForm(tags, why) {
    return '<form class="bacilead" method="post" action="/contact#baci-lead" accept-charset="UTF-8" data-baci-lead>' +
      '<input type="hidden" name="form_type" value="customer"><input type="hidden" name="utf8" value="✓">' +
      '<input type="hidden" name="contact[tags]" value="' + esc(tags) + '" data-lead-tags>' +
      '<input type="hidden" name="contact[accepts_marketing]" value="true">' +
      '<p class="bacilead__t">' + why + '</p>' +
      '<div class="bacilead__row"><input type="text" name="contact[first_name]" placeholder="Emri" autocomplete="given-name"><input type="tel" name="contact[phone]" data-lead-phone placeholder="Telefoni (WhatsApp)" autocomplete="tel"></div>' +
      '<div class="bacilead__row"><input type="email" name="contact[email]" placeholder="Email" required autocomplete="email"><button type="submit" class="btn btn--primary">Më njofto</button></div>' +
      '<p class="bacilead__fine muted">Të shkruajmë vetëm për këtë pjesë dhe për oferta të dyqanit. Mund të çregjistrohesh kur të duash.</p>' +
      '</form>';
  }

  function readPart(t) {
    for (var i = 0; i < PARTS.length; i++) for (var j = 0; j < PARTS[i].a.length; j++) if (t.indexOf(PARTS[i].a[j]) > -1) return PARTS[i];
    return null;
  }
  function readYear(t) { var m = t.match(/(19[89]\d|20[0-4]\d)/); return m ? parseInt(m[1], 10) : 0; }

  function readCar(t) {
    var best = null;
    for (var brand in FIT) {
      for (var model in FIT[brand]) {
        var gens = FIT[brand][model];
        var mn = norm(model);
        var modelHit = mn.length > 2 && t.indexOf(mn) > -1;
        for (var i = 0; i < gens.length; i++) {
          var codeBase = norm(gens[i].g).replace(' facelift', '');
          if (codeBase.length >= 2 && t.indexOf(codeBase) > -1) {
            var score = codeBase.length + (modelHit ? 2 : 0);
            if (!best || score > best.score) best = { brand: brand, model: model, gens: gens, code: codeBase, score: score };
          }
        }
        if (modelHit && (!best || best.score < 2)) best = { brand: brand, model: model, gens: gens, code: '', score: 2 };
      }
    }
    return best;
  }
  function variants(car) {
    var out = [];
    if (!car || !car.code) return out;
    for (var i = 0; i < car.gens.length; i++) if (norm(car.gens[i].g).replace(' facelift', '') === car.code) out.push(car.gens[i]);
    return out;
  }
  function pickByYear(vs, year) {
    for (var i = 0; i < vs.length; i++) { var f = vs[i].f || 0, t = vs[i].t || 9999; if (year >= f && year <= t) return vs[i]; }
    return null;
  }

  function search(q, cb) {
    fetch('/search?view=baci&type=product&q=' + encodeURIComponent(q), { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (d) { cb((d && d.products) || []); })
      .catch(function () {
        fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=10')
          .then(function (r) { return r.json(); })
          .then(function (d) { cb((d && d.resources && d.resources.results && d.resources.results.products) || []); })
          .catch(function () { cb([]); });
      });
  }
  function stockFirst(list) {
    var yes = [], no = [];
    for (var i = 0; i < list.length; i++) (list[i].available === false ? no : yes).push(list[i]);
    return yes.concat(no);
  }
  function allOut(list) {
    for (var i = 0; i < list.length; i++) if (list[i].available !== false) return false;
    return list.length > 0;
  }
  function productHtml(p) {
    var src = p.image || (p.featured_image && p.featured_image.url) || '';
    var img = src ? '<img src="' + esc(src) + '" alt="" loading="lazy">' : '';
    var price = p.price ? '<span class="price">' + esc(p.price) + '</span>' : '';
    var out = p.available === false ? ' <span class="muted" style="font-size:12px">· s’ka në stok</span>' : '';
    return '<a class="bacip" href="' + esc(p.url) + '">' + img + '<span class="bacip__t">' + esc(p.title) + out + '</span>' + price + '</a>';
  }

  function policyLine(part) {
    if (!part) return 'Përshtatjen e konfirmojmë ne para se ta porosisim. Nëse nuk përshtatet, e ndërrojmë falas — po afati është 48 orë nga marrja.';
    if (part.paint === 'GB') return 'Kjo vjen e gatshme në black gloss — pa lyerje, pa pritje, pa kosto shtesë. Nëse nuk përshtatet, e ndërrojmë falas brenda 48 orëve nga marrja.';
    if (part.paint === 'P1' || part.paint === 'P2') return 'Këtë mund ta marrësh të lyer në ngjyrën e veturës: na duhet kodi i ngjyrës (letra në kornizën e derës së djathtë të përparme) dhe 3–6 foto në dritë natyrale. Lyerja faturohet veç: 50% para se të fillojmë, pjesa tjetër kur e merr — dhe pas lyerjes nuk ka kthim as ndërrim, prandaj përshtatjen dhe kodin i konfirmojmë në telefon para se të nisë puna.';
    return 'Përshtatjen e konfirmojmë ne para se ta porosisim. Kthimi dhe ndërrimi: 48 orë nga marrja.';
  }

  function answer(raw) {
    var t = norm(raw);
    var year = readYear(t) || state.year;
    var part = readPart(t) || state.part;
    var car = readCar(t);
    if (!car && state.brand) car = { brand: state.brand, model: state.model, gens: (FIT[state.brand] || {})[state.model] || [], code: norm(state.gen).replace(' facelift', ''), score: 9 };
    if (part) state.part = part;
    if (year) state.year = year;

    var th = typing();
    setTimeout(function () {
      th.remove();
      if (!car) {
        say('Ma thuaj veturën dhe pjesën — p.sh. „parakolp para për G20 2021“ ose „difuzor për W205“. Nga modeli dhe viti e di saktësisht cila pjesë të hyn.');
        return;
      }
      state.brand = car.brand; state.model = car.model;
      var vs = variants(car);
      var two = vs.length > 1;

      if (two && !year && t.indexOf('facelift') === -1 && t.indexOf('lci') === -1) {
        var a = vs[0], b = vs[1];
        say('Për ' + esc(car.brand) + ' ' + esc(car.model) + ' ka dy versione të kësaj gjenerate, dhe pjesët e parë nuk janë të njëjta:<br><b>' + esc(a.l) + '</b> dhe <b>' + esc(b.l) + '</b>.<br>Cilin e ke? Ma thuaj vitin e prodhimit.' +
          chips([{ label: a.l, send: car.model + ' ' + a.g + ' ' + (a.f || '') }, { label: b.l, send: car.model + ' ' + b.g + ' ' + (b.f || '') }]));
        return;
      }

      var chosen = null;
      if (two && year) chosen = pickByYear(vs, year);
      if (!chosen && two && (t.indexOf('facelift') > -1 || t.indexOf('lci') > -1)) {
        for (var k = 0; k < vs.length; k++) if (norm(vs[k].g).indexOf('facelift') > -1) chosen = vs[k];
      }
      if (!chosen && vs.length === 1) chosen = vs[0];
      if (!chosen && car.gens && year) chosen = pickByYear(car.gens, year);
      if (chosen) state.gen = chosen.g;

      var label = chosen ? chosen.l : (car.code ? car.code.toUpperCase() : car.model);
      var carName = L(car.model, label);
      var what = (part ? part.k : 'pjesë') + ' për ' + car.brand + ' ' + carName;
      var base = car.code ? car.code.toUpperCase() : '';
      var qPart = [car.brand, car.model, base, part ? part.q : ''].join(' ').replace(/\s+/g, ' ').trim();
      var qCar = [car.brand, car.model, base].join(' ').replace(/\s+/g, ' ').trim();
      var F = window.BaciFilter || function (x) { return x; };

      search(qPart, function (ps) {
        var strict = F(ps, chosen, car.code, two, part ? part.w : null);
        if (strict.length) return render(stockFirst(strict), false);
        search(qCar, function (ps2) {
          var strict2 = F(ps2, chosen, car.code, two, part ? part.w : null);
          if (strict2.length) return render(stockFirst(strict2), false);
          var loose = F(ps2, chosen, car.code, two, null);
          render(stockFirst(loose), true);
        });

        function render(list, widened) {
          if (!list.length) {
            say('<b>' + esc(what) + '</b> nuk e kemi në faqe tash — dhe nuk po të tregoj pjesë të versionit tjetër, sepse nuk të hyjnë. Po e marrim si kërkesë: lëre kontaktin dhe të përgjigjemi a e sjellim dhe kur.' +
              leadForm('kerkese, kerkese:' + slug(what) + ', source:baci', 'Të shkruajmë për <b>' + esc(what) + '</b>:') +
              '<p class="bacinext">Ose ' + waLink('Përshendetje, kërkoj ' + what) + ' tash.</p>');
            return;
          }
          var head, tail = '';
          if (!widened && part && allOut(list)) {
            var p0 = list[0];
            head = '<b>' + esc(part.k) + '</b> për <b>' + esc(carName) + '</b> e kemi në katalog, po tash <b>nuk është në stok</b> — porositet:';
            tail = leadForm('restock, restock:' + (p0.handle || slug(p0.title)) + (p0.variant ? ', variant:' + p0.variant : '') + ', source:baci', 'Lëre kontaktin dhe të njoftojmë vetë sapo të vijë:') +
              '<p class="bacinext">Ose ' + waLink('Përshendetje, kur vjen ' + what + '?') + ' për ditën e saktë.</p>';
          } else if (widened && part) {
            head = 'Pikërisht <b>' + esc(part.k) + '</b> për <b>' + esc(carName) + '</b> nuk po e gjej në faqe. Këto janë për të njëjtin version të veturës:';
            tail = leadForm('kerkese, kerkese:' + slug(what) + ', source:baci', 'Nëse e do pikërisht <b>' + esc(part.k) + '</b>, lëre kontaktin dhe të përgjigjemi a e sjellim:') +
              '<p class="bacinext">Ose ' + waLink('Përshendetje, kërkoj ' + what) + '.</p>';
          } else if (part) {
            head = '<b>' + esc(part.k) + '</b> për <b>' + esc(carName) + '</b> — kjo kemi:';
          } else {
            head = 'Për <b>' + esc(carName) + '</b> kemi këto:';
          }
          var body = '<div class="baciprods">';
          for (var i = 0; i < Math.min(3, list.length); i++) body += productHtml(list[i]);
          body += '</div>';
          if (!tail) tail = '<p class="bacinext">Nëse ma thua edhe versionin (M Packet, R-Line, AMG Line) ose ma dërgon një foto të pjesës që ke tash, e mbyllim pa gabim. ' + waLink('Përshendetje, ' + what) + '</p>';
          say(head + body + '<p class="bacipolicy">' + policyLine(part) + '</p>' + tail);
        }
      });
    }, 320);
  }

  function ask(v) { if (!v) return; say(esc(v), 'me'); answer(v); }
  window.BaciAsk = ask;
  window.BACI_READY = true;

  if (/customer_posted=true/.test(location.search)) {
    say('<b>U regjistrua.</b> Të shkruajmë sapo të kemi përgjigje për pjesën — me email, dhe në WhatsApp nëse ke lënë numrin.');
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    e.stopImmediatePropagation();
    var v = (input.value || '').trim();
    input.value = '';
    ask(v);
  }, true);

  root.addEventListener('submit', function (e) {
    var lf = e.target.closest('[data-baci-lead]');
    if (!lf) return;
    var p = lf.querySelector('[data-lead-phone]'), tg = lf.querySelector('[data-lead-tags]');
    if (p && tg && p.value.trim()) tg.value = tg.value + ', tel:' + p.value.replace(/[^0-9+]/g, '');
  }, true);

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-baci-send], [data-baci-fill]');
    if (!b || !root.contains(b)) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    ask(b.getAttribute('data-baci-send') || b.getAttribute('data-baci-fill'));
  }, true);
})();
